var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputVal),expression:"inputVal"}],staticClass:"survey-input-xs",attrs:{"type":"number","placeholder":"0.00","required":"","value":"0","step":"any"},domProps:{"value":(_vm.inputVal)},on:{"input":function($event){if($event.target.composing)return;_vm.inputVal=$event.target.value}}})
}
var staticRenderFns = []

export { render, staticRenderFns }